/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".edit-place-category-modal .edit-wrap{max-height:500px;overflow-y:auto;overflow-x:hidden;text-align:left}"];
export { styles as styles };



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/hub/edit.place.category.modal/edit.place.category.modal.component.scss.ngstyle.js.pre-build-optimizer.js